import { createContext } from 'react';
import { UserCtxData } from './UserCtxData';

/**
 * User context instantiation, includes default values
 * (undefined name, no permissions, and no-ops for the functions)
 * https://reactjs.org/docs/context.html
 */
export const UserCtx = createContext(UserCtxData.empty());
